export default __webpack_public_path__ + "static/media/side_logout.72fa2ef4.svg";